import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useIsDesktop } from '../utils';

import './lesson-content__problem-overlay.scss';

export const LessonContentProblemOverlay = () => {
    const isDesktop = useIsDesktop();
    return (
        <div className="lesson-content__problem-overlay">
            <div className="lesson-content__problem-overlay-content">
                {isDesktop ? (
                    <FormattedMessage id="lessonContent.webProblemOverlay" />
                ) : (
                    <FormattedMessage id="lessonContent.webProblemOverlayMobile" />
                )}
            </div>
        </div>
    );
};
